
<template>
    <div>
        <hr>
        <h2 class="text-center text-uppercase">
            Breakdowns of
            <em class="text-danger">
                {{ payment.title }}
                {{ payment.assessment_type ? '(' + payment.assessment_type.title + ')' : '' }}
            </em>
            Batch Payment

        </h2>
        <h3 class="text-center text-uppercase" v-if="payment.amount">
            Total Amount:
            <em class="text-danger">{{ payment.amount | formatPrice }}</em>
        </h3>
        <hr>
        <div class="card shadow" v-if="breakdowns && breakdowns.length > 0">
            <div class="table-responsive">
                <base-table
                    class="table align-items-center table-flush"
                    thead-classes="thead-light"
                    tbody-classes="list"
                    :data="breakdowns"
                >
                    <template slot="columns">
                        <th width="2%">S/N</th>
                        <th width="15%">Title</th>
                        <th width="10%">Amount</th>
                        <th width="10%">Date Created</th>
                        <th width="10%">&nbsp;</th>
                    </template>

                    <template
                        slot-scope="{row, index}"
                    >
                        <td class="budget">
                            {{ index+1 }}
                        </td>
                        <td class="text-capitalize">
                            {{ row.title }}
                        </td>
                        <td class="text-capitalize">
                            {{ row.amount | formatPrice }}
                        </td>
                        <td class="text-capitalize">
                            {{ row.created_at | formatDate }}
                        </td>
                        <td>
                            <button
                                class="btn btn-sm btn-info"
                                :disabled="(privileges && privileges.update == 'no') || ! privileges"
                                @click="$emit('editPaymentBreakdown', row)"
                            >
                                <i class="fa fa-pen"></i>
                                Edit
                            </button>

                            <button
                                class="btn btn-sm btn-danger"
                                :disabled="(privileges && privileges.delete == 'no') || ! privileges"
                                @click="deleteBreakdown(row.id)"
                            >
                                <i class="fa fa-ban"></i>
                                Remove
                            </button>
                        </td>
                    </template>
                </base-table>
            </div>
        </div>

        <div
            class="col-sm-12 text-center"
            v-if="breakdowns && breakdowns.length == 0"
        >
            <base-alert type="warning">
                <span class="alert-inner--icon"><i class="ni ni-like-2"></i></span>
                <span class="alert-inner--text">
                    No Breakdowns added yet!!!
                </span>
            </base-alert>
        </div>
    </div>
</template>
<script>
    import swal from 'sweetalert2';// import sweet alert
    import { mapActions } from 'vuex';
    import moment from 'moment';

    export default {
        name: 'BatchPaymentBreakdownData',
        props: ['breakdowns', 'privileges', 'payment', 'viewBreakdowns'],
        filters: {
            formatPrice(value) {
                if(value) {
                    let val = (value/1).toFixed(2).replace(',', '.');
                    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")+ ' NGN';
                } else {
                    return 'N/A';
                }
            },
            formatDate(value) {
                return value ? moment(value).format('Do MMM, YYYY') : 'N/A';
            }
        },
        methods: {
            ...mapActions(['deleteBatchPaymentBreakdown']),
            deleteBreakdown(id) {
                swal.fire({
                    title: 'Are you sure?',
                    text: "You won't be able to revert this!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, Proceed!'
                }).then((result) => {
                    if (result.value) {
                        this.makeRemoveApiCall(id);// make api call
                    }
                });
            },
            makeRemoveApiCall(id) {
                this.preloader(); // show loading
                this.deleteBatchPaymentBreakdown(id).then((res) => {// delete country
                    this.viewBreakdowns(this.payment, true);// refresh page
                    if(res.status) {
                        swal.fire("Breakdown Deleted", res.msg, "success");
                    } else {
                        swal.fire("Error Occurred!", res.msg, "warning");
                    }
                }).
                catch(err => {
                    this.viewBreakdowns(this.payment, true);// refresh page
                    swal.fire(err.message+"!", "An error occurred while deleting, try again", "warning");
                });
            },
            preloader() {
                return  swal.fire({
                    title: 'Please Wait...',
                    html: 'Trying to fetch data from <b>server</b>',
                    // timer: 2000,
                    timerProgressBar: true,
                    onBeforeOpen: () => {
                        swal.showLoading()
                    },
                });
            }
        }
    };
</script>
<style>
    .table td {
        font-size: 15px;
    }
</style>
